function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 19L0 19L0 0Z",
  id: "crm_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "crm_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#crm_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "crm-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 19L0 19L0 0Z",
  id: "crm-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#crm_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 0.7988281)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.31523 0C0.590039 0 0 0.700672 0 1.56184L0 15.8416C0 16.7028 0.590039 17.4034 1.31523 17.4034L18.6848 17.4034C19.41 17.4034 20 16.7027 20 15.8416L20 1.56184C20 0.700672 19.41 0 18.6848 0L1.31523 0ZM1.31523 16.6597C0.935351 16.6597 0.626289 16.2927 0.626289 15.8416L0.626289 1.56184C0.626289 1.11073 0.935351 0.743718 1.31523 0.743718L4.67641 0.743718L4.67641 16.6597L4.67641 16.6597L1.31523 16.6597ZM18.6848 16.6597L5.30273 16.6597L5.30273 0.743765L18.6848 0.743765C19.0646 0.743765 19.3737 1.11078 19.3737 1.56189L19.3737 15.8416C19.3737 16.2927 19.0646 16.6597 18.6848 16.6597Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.0126953 2.3847656)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.313164 0C0.140234 0 0 0.166482 0 0.371882C0 0.577283 0.140195 0.743765 0.313164 0.743765L1.6493 0.743765C1.82223 0.743765 1.96246 0.577283 1.96246 0.371882C1.96246 0.166482 1.82223 0 1.6493 0L0.313164 0Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.3359375 2.3847656)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.313164 0C0.140234 0 0 0.166482 0 0.371882C0 0.577283 0.140195 0.743765 0.313164 0.743765L2.31734 0.743765C2.49027 0.743765 2.63051 0.577283 2.63051 0.371882C2.63051 0.166482 2.49031 0 2.31734 0L0.313164 0Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.3359375 4.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.313164 0C0.140234 0 0 0.166482 0 0.371882C0 0.577282 0.140195 0.743764 0.313164 0.743764L2.31734 0.743764C2.49027 0.743764 2.63051 0.577282 2.63051 0.371882C2.63051 0.166482 2.49031 0 2.31734 0L0.313164 0Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.3359375 15.078125)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.313164 0C0.140234 0 0 0.166482 0 0.371883C0 0.577237 0.140195 0.743766 0.313164 0.743766L1.6493 0.743766C1.82223 0.743766 1.96246 0.577284 1.96246 0.371883C1.96246 0.166482 1.82223 0 1.6493 0L0.313164 0Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(16.701172 2.3847656)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.313164 0C0.140234 0 0 0.166482 0 0.371882C0 0.577283 0.140195 0.743765 0.313164 0.743765L1.6493 0.743765C1.82223 0.743765 1.96246 0.577283 1.96246 0.371882C1.96246 0.166482 1.82223 0 1.6493 0L0.313164 0Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.3466797 7.5410156)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.06918 3.32184C2.80996 3.73158 2.41418 3.96657 1.98332 3.96657C1.23508 3.96657 0.626329 3.24368 0.626329 2.35515C0.626329 1.46661 1.23508 0.743718 1.98332 0.743718C2.41449 0.743718 2.81051 0.979038 3.06965 1.38928C3.17344 1.55354 3.36973 1.58689 3.50805 1.46359C3.64637 1.3403 3.67438 1.10725 3.57063 0.942995C3.19199 0.343679 2.61348 0 1.98328 0C0.889727 0 0 1.05655 0 2.35515C0 3.65374 0.889727 4.71029 1.98328 4.71029C2.61297 4.71029 3.19125 4.36703 3.56988 3.7685C3.67383 3.60429 3.64594 3.3712 3.50762 3.24786C3.36934 3.12452 3.17301 3.15764 3.06918 3.32184Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(10.688477 7.5410156)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.29856 1.56184C3.29856 0.700625 2.70852 0 1.98332 0L0.313164 0C0.140234 0 0 0.166482 0 0.371882L0 4.33846C0 4.54381 0.140195 4.71034 0.313164 4.71034C0.486133 4.71034 0.626328 4.54386 0.626328 4.33846L0.626328 3.12368L1.49274 3.12368L2.40086 4.56158C2.46242 4.65899 2.55645 4.71034 2.65164 4.71034C2.71703 4.71034 2.78297 4.68608 2.8393 4.63598C2.97762 4.51278 3.0057 4.27964 2.90191 4.11538L2.25442 3.09019C2.85 2.94134 3.29856 2.31275 3.29856 1.56184ZM0.62629 0.743811L1.98328 0.743811C2.36316 0.743811 2.67223 1.11082 2.67223 1.56193C2.67223 2.01304 2.36316 2.38006 1.98328 2.38006L0.62629 2.38006L0.62629 2.38001L0.62629 0.743811Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(14.363281 7.5410156)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.63106 0.334896C3.61669 0.164425 3.50614 0.0276771 3.36329 0.00369512C3.2206 -0.0203332 3.08228 0.0747131 3.02872 0.233819L1.98333 3.33723L0.93794 0.233819C0.884346 0.0747595 0.746221 -0.0201013 0.60337 0.00369512C0.460518 0.0276771 0.349972 0.164425 0.335597 0.334896L0.0015739 4.30147C-0.0156136 4.50585 0.109933 4.68806 0.282042 4.70851C0.453956 4.72892 0.60755 4.57984 0.624815 4.37546L0.831573 1.92035L1.69263 4.47658C1.74021 4.61773 1.85528 4.71032 1.98337 4.71032C2.11146 4.71032 2.22657 4.61773 2.27411 4.47658L3.13517 1.92035L3.34192 4.37546C3.3581 4.56722 3.49419 4.71032 3.65317 4.71032C3.6636 4.71032 3.67411 4.70972 3.6847 4.70842C3.85673 4.68806 3.98228 4.5058 3.96509 4.30142L3.63106 0.334896Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgCrm = function SvgCrm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crm.0793ac2f.svg";
export { ForwardRef as ReactComponent };